import { createContext, useContext, useMemo } from 'react';

const context = createContext<string | null>(null);

export const ScopedClassNameProvider = ({
  children,
  base,
}: {
  children: React.ReactNode;
  base: string;
}) => {
  return <context.Provider value={base}>{children}</context.Provider>;
};

export const useScopedClassName = (suffix: string) => {
  const base = useContext(context);
  if (base === null) {
    throw new Error(
      `useScopedClassName(${suffix}) must be used within a ScopedClassNameProvider`,
    );
  }
  return useMemo(() => {
    return `${base}__${suffix}`;
  }, [base, suffix]);
};
